import { oc } from '@orpc/contract';
import { saveTrackerValuesInputSchema, saveTrackerValuesOutputSchema } from '../schemas/tracker.schemas.js';
export const saveTrackerValuesContract = oc
    .route({
    method: 'POST',
    path: '/tracker/values',
    tags: ['Tracker'],
    summary: 'Save staged weekly values and notes atomically; EDIT on each pillar re-checked, calculated KPIs rejected, unit rounding applied',
})
    .input(saveTrackerValuesInputSchema)
    .output(saveTrackerValuesOutputSchema);
//# sourceMappingURL=save-tracker-values.contract.js.map